module.exports = __webpack_public_path__ + "img/file.9192f5e7.png";